import { Box, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetCustomerQuery } from 'services/customers'
import useGlobalLoader from 'utils/custom-hooks/useGlobalLoader'
import LocationsGrid from './LocationsGrid'
import { useCustomerHeader } from '../account/utils'
import { formatAddress, convertShippingInfoToCityStateZip } from 'utils/data-manipulation/valueFormatter'

const CustomerLocations = () => {
  const { id: customerId } = useParams()
  const { data: customerData, isLoading } = useGetCustomerQuery({ customerId }, { skip: !customerId })

  useCustomerHeader(customerData)
  useGlobalLoader(isLoading)

  if (isLoading) return null

  const locationRows = customerData?.locations?.map(location => {
    const address = `${formatAddress(location)}, ${convertShippingInfoToCityStateZip(location)}`
    const primaryContact = customerData?.contacts?.find(contact => contact.id === location?.primaryContactId)
    return {
      ...location,
      fullAddress: address,
      primaryContactName: `${primaryContact?.firstName || ''} ${primaryContact?.lastName || ''}`,
    }
  })

  return (
    <Box p={3} data-testid="customer-vehicles-information">
      <Grid container rowSpacing={4}>
        <Grid item xs={12}>
          <Typography variant="h5">Locations</Typography>
        </Grid>
        <Grid item xs={12} display="flex" flexDirection="column">
          <LocationsGrid rows={locationRows} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default CustomerLocations
